import clsx from 'clsx';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Menu, MenuItem } from '@/components/dropdownMenu/dropdownMenu';
import { EXAMPLE_TYPE_DISPLAY_NAMES, EXAMPLE_TYPES, ExampleTypeEnum } from '@/types/evals';

import styles from './modalSourceCreate.module.scss';

const EXAMPLE_TYPE_OPTIONS: ExampleTypeEnum[] = [
  EXAMPLE_TYPES.CONVERSATION,
  EXAMPLE_TYPES.MESSAGE
];

type ExampleTypeSelectProps = {
  disabled?: boolean;
};

export const ExampleTypeSelect: React.FC<ExampleTypeSelectProps> = ( { disabled } ) => {
  const { watch, setValue, formState: { errors } } = useFormContext();
  const exampleTypeError = errors.example_type as { message?: string } | undefined;
  const exampleType = watch( 'example_type' ) as ExampleTypeEnum | undefined;

  return (
    <div className={ clsx( 'layout__col', 'pad' ) } data-testid="example-type-selection">
      <label className={ clsx( 'auth_flow_label', exampleTypeError && 'required' ) }>
        Select Example Type <span className={ styles.required_asterisk }>*</span>
      </label>
      <Menu
        variant="select"
        className={ clsx( styles.source_type_select, !exampleType && styles.source_type_placeholder ) }
        value={ exampleType ? EXAMPLE_TYPE_DISPLAY_NAMES[ exampleType ] : 'Select Example Type' }
        data-testid="example-type-dropdown"
        disabled={ disabled }
      >
        {EXAMPLE_TYPE_OPTIONS.map( ( type ) => (
          <MenuItem
            key={ type }
            value={ EXAMPLE_TYPE_DISPLAY_NAMES[ type ] }
            data-testid={ `example-type-option-${ type }` }
            onClick={ () => setValue( 'example_type', type ) }
          />
        ) )}
      </Menu>
      {exampleTypeError && (
        <div className={ styles.error_message }>
          {exampleTypeError.message || 'Please select an example type'}
        </div>
      )}
    </div>
  );
};
